import { useMemo } from "react";
import { useGetVenueQuery, useGetVenuesQuery } from "./venueEndpoints";
import { Venue } from "../../entities/venue";
import { Ids } from "../../reducers/rhapsody";

export function useVenue(ids?: Ids) {
  const venueQuery = useGetVenueQuery(ids, {
    skip: (ids?.id ?? 0) <= 0,
  });
  const venueEntity = venueQuery.data;

  return useMemo(() => {
    const ret: typeof venueQuery & { venue?: Venue | undefined } = {
      ...venueQuery,
    };
    if (venueEntity) ret.venue = new Venue(venueEntity);
    return ret;
  }, [venueEntity]);
}

export function useVenues() {
  const venueQuery = useGetVenuesQuery();
  const venueEntitiesMap = venueQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof venueQuery & {
      venues?: Venue[];
      venuesMap?: { [id: number]: Venue };
    } = {
      ...venueQuery,
      venues: [],
      venuesMap: {},
    };
    if (venueEntitiesMap) {
      const venues: Venue[] = [];
      const venuesMap: { [id: number]: Venue } = {};

      for (const key in venueEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(venueEntitiesMap, key)) {
          const c = venueEntitiesMap[key];
          const venue = new Venue(c);
          venues.push(venue);
          venuesMap[venue.id] = venue;
        }
      }
      venues.sort((a, b) => a.name.localeCompare(b.name));
      ret.venues = venues;
      ret.venuesMap = venuesMap;
    }

    return ret;
  }, [venueEntitiesMap]);
}
